import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

//解决vue路由重复导航错误
//获取原型对象上的push函数
const orginalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  //修改原型对象中的push方法
  return orginalPush.call(this, location).catch(err => err)
};


/* Layout */
export const Layout = () =>import('@/layout/index.vue');

export const constantRoutes = [
  // {
  //   path: '/',
  //   hidden: true,
  //   redirect: '/home'
  // },
  {
    path: '/',
    component: Layout,
    redirect:'/home',
    children:[
      {
        path: '/home',
        component: () => import('@/views/home/index'),
        name: 'Home',
        meta: { title: '首页', icon: 'homepage', affix: true }
      },
    ]
  },
  {
    path:'/aboutTY',
    component: Layout,
    redirect:'/introduction',
    children:[
      {
        path: '/introduction',
        component: () => import('@/views/aboutTY/introduction/index.vue'),
        name: 'Introduction',
        meta: { title: '企业介绍', icon: 'homepage', affix: true }
      },
      {
        path: '/enterpriseQualification',
        component: () => import('@/views/aboutTY/enterpriseQualification/index.vue'),
        name: 'EnterpriseQualification',
        meta: { title: '企业资质', icon: 'homepage', affix: true }
      },
      {
        path: '/tyGlory',
        component: () => import('@/views/aboutTY/tyGlory/index.vue'),
        name: 'TyGlory',
        meta: { title: '天音荣誉', icon: 'homepage', affix: true }
      },
      {
        path: '/innovationArea',
        component: () => import('@/views/aboutTY/innovationArea/index.vue'),
        name: 'InnovationArea',
        meta: { title: '创新领域', icon: 'homepage', affix: true }
      },
      {
        path: '/service',
        component: () => import('@/views/aboutTY/service/index.vue'),
        name: 'Service',
        meta: { title: '售后服务', icon: 'homepage', affix: true }
      },
      {
        path: '/industryNews',
        component: () => import('@/views/aboutTY/industryNews/index.vue'),
        name: 'IndustryNews',
        meta: { title: '行业资讯', icon: 'homepage', affix: true }
      },
      {
        path: '/industryNewInfo',
        component: () => import('@/views/aboutTY/industryNews/industryNewInfo.vue'),
        name: 'IndustryNewsInfo',
        meta: { title: '行业资讯详情', icon: 'homepage', affix: true }
      },
    ]
  },
  {
    path:'/tyProduct',
    component: Layout,
    redirect:'/sysFeature',
    children:[
      {
        path: '/sysFeature',
        component: () => import('@/views/tyProduct/sysFeature/index.vue'),
        name: 'SysFeature',
        meta: { title: '系统特点', icon: 'homepage', affix: true }
      },
      {
        path: '/software',
        component: () => import('@/views/tyProduct/software/index.vue'),
        name: 'Software',
        meta: { title: '软件功能', icon: 'homepage', affix: true }
      },
      {
        path: '/vodProduct:id?',
        component: () => import('@/views/tyProduct/vodProduct/index.vue'),
        name: 'VodProduct',
        meta: { title: '智能硬件', icon: 'homepage', affix: true }
      },
    ]
  },
  {
    path:'/cashier',
    component: Layout,
    redirect:'/cashierIntroduction',
    children:[
      {
        path: '/cashierIntroduction',
        component: () => import('@/views/cashier/cashierIntroduction/index.vue'),
        name: 'CashierIntroduction',
        meta: { title: '系统介绍', icon: 'homepage', affix: true }
      },
      {
        path: '/cashierProduct',
        component: () => import('@/views/cashier/cashierProduct/index.vue'),
        name: 'CashierProduct',
        meta: { title: '产品功能', icon: 'homepage', affix: true }
      },
    ]
  },
  {
    path:'/incrementService',
    component: Layout,
    redirect:'/incrementService',
    children:[
      {
        path: '/incrementService',
        component: () => import('@/views/incrementService/index'),
        name: 'IncrementService',
        meta: { title: '增值服务系统', icon: 'homepage', affix: true }
      }
    ],

  },

  {
    path:'/contactUs',
    component: Layout,
    redirect:'/contactUs',
    children:[
      {
        path: '/contactUs',
        component: () => import('@/views/contactUs/index'),
        name: 'ContactUs',
        meta: { title: '联系我们', icon: 'homepage', affix: true }
      }
    ],

  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404.vue'),
    hidden: true
  },
  {
    path: '/403',
    component: () => import('@/views/errorPage/403.vue'),
    hidden: true
  },


];

export const asyncRoutes = [

];

const createRouter = () => new Router({
  scrollBehavior: (to, from, savedPosition) => {
    return { x:0,y: 0, behavior:'smooth'}
  },
  routes: constantRoutes
});

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher // reset router
}

export default router
